export default __webpack_public_path__ + "static/mitech-client-logo-02-hover-991fb5ac66b028a0891cf4a42005c28d.png";